<script>
export default {
  props: {
    layout: { type: String, required: true },
    layoutComponents: { type: Array, required: true },
    property: { type: Object, required: true },
  },

  data() {
    return {
      backgroundUrl: '/images/hero-main.jpg',
    }
  },
}
</script>

<template>
  <div
    id="bg-screen"
    class="bg-cover bg-center h-screen"
    :style="{ 'background-image': `url(${backgroundUrl})` }"
  >
    <main class="relative">
      <router-view></router-view>
    </main>
  </div>
</template>
